import {
  Spaceable
} from "./chunk.LC2BHSCA.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  D,
  ke,
  r as r2
} from "./chunk.WKUNRGJV.js";
import {
  n
} from "./chunk.BBN2ZB42.js";
import {
  i,
  r
} from "./chunk.FAJKIEWS.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/jb-image/jb-image.scss?inline
var jb_image_default = i`*,
*::before,
*::after {
  box-sizing: border-box;
}

*:focus-visible {
  outline-color: rgb(var(--theme-color-signal-blue, 0 37 255));
  outline-offset: 6px;
  outline-style: var(--focus-outline-style, auto);
}

div,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
ol,
ul,
li,
form,
legend,
label,
table,
header,
footer,
nav,
section,
figure {
  margin: 0;
  padding: 0;
}

a {
  color: inherit;
}

/* COLOR SETTINGS */
/* shadows */
/* special measurements */
/* stylelint-disable */
/* stylelint-enable */
.caption, .credit, .text {
  font-family: var(--theme-font-light-family, VerlagSSm, Tahoma, sans-serif);
  font-style: normal;
  font-weight: var(--theme-font-light-weight, 300);
}

.text {
  color: rgba(var(--rgb-primary, 20, 30, 85), var(--text-opacity, var(--theme-opacity-80, 0.8)));
  font-size: 1rem;
  line-height: 1.625rem;
}

.credit {
  color: rgba(var(--rgb-primary, 20, 30, 85), var(--text-opacity, var(--theme-opacity-70, 0.7)));
  font-size: 0.813rem;
  line-height: 1.25rem;
}

.caption {
  color: rgb(var(--rgb-primary, 20, 30, 85));
  font-size: 1.313rem;
  line-height: 2.125rem;
}
@media (min-width: 1281px) {
  .caption {
    font-size: 1.5rem;
    line-height: 2.25rem;
  }
}

/* special measurements */
:host {
  color: var(--host-color, #141e55);
}

:host {
  display: block;
}

@media (max-width: 599px) {
  p {
    margin-left: var(--paragraphs-margin-left, var(--theme-row-small-margin, 6.68%));
    margin-right: var(--paragraphs-margin-right, var(--theme-row-small-margin, 6.68%));
  }
}
@media (min-width: 600px) and (max-width: 959px) {
  p {
    margin-left: var(--paragraphs-margin-left, calc(8.35% + 20px));
    margin-right: var(--paragraphs-margin-right, calc(8.35% + 20px));
  }
}

.caption {
  font-size: var(--image-caption-font-size, 1.313rem);
  line-height: var(--image-caption-line-height, 2.125rem);
  margin-top: var(--image-caption-margin-top, 16px);
}
@media (min-width: 1281px) {
  .caption {
    font-size: var(--image-caption-font-size, 1.5rem);
    line-height: var(--image-caption-line-height, 2.25rem);
  }
}

.text {
  margin-top: 16px;
}

.credit {
  color: rgba(20, 30, 85, 0.7);
  margin-top: var(--image-credit-margin-top, 5px);
}`;

// src/components/jb-image/jb-image.ts
var JbImage = class extends Spaceable(r2) {
  _getContentSpacingProperties() {
    return { type: "media" };
  }
  render() {
    return ke`
      <div>
        <jb-picture
          .alt=${this.picture.alt}
          .imgData=${this.picture.imgData}
          .lazy=${this.picture.lazy}
        ></jb-picture>
        ${this.caption ? ke`<p class="caption">${this.caption}</p>` : D}
        ${this.text ? ke`<p class="text">${this.text}</p>` : D}
        ${this.credit ? ke`<p class="credit">${this.credit}</p>` : D}
      </div>
    `;
  }
};
JbImage.styles = r(jb_image_default);
__decorateClass([
  n()
], JbImage.prototype, "caption", 2);
__decorateClass([
  n()
], JbImage.prototype, "credit", 2);
__decorateClass([
  n({ type: Object })
], JbImage.prototype, "picture", 2);
__decorateClass([
  n()
], JbImage.prototype, "text", 2);
JbImage = __decorateClass([
  customElement("jb-image")
], JbImage);

export {
  JbImage
};
